import React from 'react';
import { CardBody } from '../../shared/card/card-body';
import './card-error-handling.scss';
export var CardErrorHandlingBody = function (_a) {
    var title = _a.title, content = _a.content;
    return (React.createElement(CardBody, null,
        React.createElement("div", { className: "s-card-bad-redirects__detail" },
            React.createElement("div", { className: "s-card-bad-redirects__detail__content" },
                React.createElement("b", null, title))),
        React.createElement("div", { className: "s-card-bad-redirects__detail" },
            React.createElement("div", { className: "c-cart__detail__content" },
                React.createElement("p", null, content)))));
};
